import { EmployeeWeekOffUploadsServices, OverTimeService, ShiftService } from '@gtpl/shared-services/hrms';
import { DepartmentService, EmployeeService, UnitcodeService } from '@gtpl/shared-services/masters';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { TeamCalenderRepository } from '../team-calender/repository/team-calender.repository';
import { TeamCalenderAdapter } from '../team-calender/team-calender.adapter';
import { TeamCalenderService } from '../team-calender/team-calender.service';
import { AttendanceHelperService } from './attendance-helper.service';
import { WhatsappNotifyService } from './attendance-whatsapp.service';
import { AttendanceController } from './attendance.controller';
import { AttendanceService } from './attendance.service';
import { AttendanceLogAdapter } from './dto/attendance-log.adapter';
import { AttendanceAdapter } from './dto/attendance.adapter';
import { AttendanceAdjustmentAdapter } from './dto/attn-adjust.adapter';
import { AttendanceAdjustmentRepository } from './repository/attendance-adjustment.repository';
import { AttendanceLogRepository } from './repository/attendance-log.repository';
import { AttendanceRepository } from './repository/attendance.repository';
import { HolidaysCalendarService } from '@gtpl/shared-services/hrms'
import { ConsolidatedAttendanceLogRepository } from './repository/consolidated-attendance-log.repository';

@Module({
    imports: [
        TypeOrmModule.forFeature([AttendanceLogRepository, AttendanceRepository, TeamCalenderRepository, AttendanceAdjustmentRepository, ConsolidatedAttendanceLogRepository])
    ],
    controllers: [AttendanceController],
    providers: [AttendanceService, AttendanceLogAdapter, EmployeeService, DepartmentService, AttendanceAdapter, ApplicationExceptionHandler, AttendanceHelperService, TeamCalenderService, TeamCalenderAdapter, WhatsappNotifyService, WhatsAppNotificationService, WhatsappBroadCastService, AttendanceAdjustmentRepository, AttendanceAdjustmentAdapter, ShiftService, UnitcodeService, OverTimeService ,HolidaysCalendarService ,EmployeeWeekOffUploadsServices],
    exports: [AttendanceService, AttendanceHelperService, WhatsappNotifyService]
})
export class AttendanceModule { }